// test802
(802 && 0);
